<script>
  import DateOptionsDropdown from "@components/shared/date-options-dropdown.svelte";
  import { cn, formatDateISO } from "@lib/utils";

  let { 
    start = $bindable(null), 
    end = $bindable(null), 
    class: className,
    labels = ["Début", "Fin"],
    names = ["start_date", "end_date"],
    options = true // true, false, future, past
  } = $props();

  function setDates(range) {
    start = formatDateISO(range[0]);
    end = formatDateISO(range[1]);
  }
  
</script>

<div class={cn("flex items-center gap-2", className)}>

  <div class="form-item flex-1">
    <label for={names[0]}>{labels[0]}</label>
    <input type="date" name={names[0]} id={names[0]} class="input" bind:value={start} required />
  </div>

  <div class="form-item flex-1">
    <label for={names[1]}>{labels[1]}</label>
    <input type="date" name={names[1]} id={names[1]} class="input" bind:value={end} min={start} required />
  </div>

  <div class="form-item">
    <!-- A blank label to maintain correct height -->
    <label>&nbsp;</label>
    {#if options}
      <DateOptionsDropdown onChange={setDates} {options} />
    {/if}
  </div>
  
</div>
